import React from "react";

import CommonButton from "../../../../components/Button";
import { EvacuationStatusType } from "../../../../types/emergency";
import clsx from "clsx";

export type SituationStatusButtonProps = {
  status: EvacuationStatusType;
  icon: string;
  title: string;
  description?: string;
  onClick: () => void;
  disabled?: boolean;
  isMultiColumn?: boolean;
  activeDescription?: string;
  isActive?: boolean;
  activeButton?: React.ReactNode;
};

export default function SituationStatusButton({
  onClick,
  icon,
  title,
  description,
  disabled,
  isMultiColumn,
  isActive,
  activeDescription,
  activeButton,
}: SituationStatusButtonProps) {
  return (
    <CommonButton
      variant="emergency-status"
      onClick={!isActive ? onClick : undefined}
      disabled={disabled}
      className={clsx([
        "flex-1",
        { "border-[2px] border-[#E40B0B] shadow-md": isActive },
      ])}
    >
      {isMultiColumn ? (
        <div className="flex flex-col gap-2.5 items-center">
          <div>
            <img src={icon} alt="emergency-main-vacation-icon" />
          </div>
          <span className="text-base leading-[19px] font-semibold">
            {title}
          </span>
        </div>
      ) : (
        <div className="flex gap-[15px] items-center">
          <img src={icon} alt="emergency-main-help-icon" />
          <div className="flex flex-col gap-1.5 items-start">
            <span className="text-base leading-[19px] font-semibold">
              {title}
            </span>
            <span className="text-xs leading-4 text-brand-neutral-50 whitespace-pre-line text-start">
              {isActive ? activeDescription : description}
            </span>
          </div>
          {isActive && activeButton}
        </div>
      )}
    </CommonButton>
  );
}
